import { formatTranslation } from 'intl';
import type { IntlShape } from 'react-intl';
import type { ChartDefinition } from '../catalog/types';

export function resolveChartCardSubtitle(
  definition: ChartDefinition | undefined,
  intl: IntlShape
): string | undefined {
  const subtitleId = definition?.subtitleId;
  if (!subtitleId) {
    return undefined;
  }

  return formatTranslation(intl, subtitleId);
}
